import field from '../messages/field/en'
import format from '../messages/format/en'
import navigation from '../messages/navigation/en'
import parser from '../messages/parser/en'

export default {
  navigation,
  parser,
  field,
  format
}